import Repository from "../Repository";
import Utils from "../Utils";

const resource = "/service.php/config";
export default {

    getConfig() { //https://adcontrol.adalliance.io/api/service.php/config/openConfig
        return Repository.get(`${resource}/openConfig${Utils.appendCorsParam()}`);
    },
    getSizeDetails(id) {
        return Repository.get(`${resource}/getSizesDetails${Utils.appendCorsParam()}&size_id=${id}`);
    },
    editSize(json) {
        return Repository.post(`${resource}/editSize${Utils.appendCorsParam()}`, Utils.toFormData(json));
    },
    deleteSize(json) {
        return Repository.post(`${resource}/deleteSize${Utils.appendCorsParam()}`, Utils.toFormData(json));
    },
    getPublisherDetails(id) {
        return Repository.get(`${resource}/getPublisherDetails${Utils.appendCorsParam()}&publisher_id=${id}`);
    },
    editPublisher(json) {
        return Repository.post(`${resource}/editPublisher${Utils.appendCorsParam()}`, Utils.toFormData(json));
    },
    deletePublisher(json) {
        return Repository.post(`${resource}/deletePublisher${Utils.appendCorsParam()}`, Utils.toFormData(json));
    },
    getPositionsDetails(id) {
        return Repository.get(`${resource}/getPositionsDetails${Utils.appendCorsParam()}&position_id=${id}`);
    },
    editPosition(json) {
        return Repository.post(`${resource}/editPosition${Utils.appendCorsParam()}`, Utils.toFormData(json));
    },
    deletePosition(json) {
        return Repository.post(`${resource}/deletePosition${Utils.appendCorsParam()}`, Utils.toFormData(json));
    },
    getModuleDetails(id) {
        return Repository.get(`${resource}/getModuleDetails${Utils.appendCorsParam()}&module_id=${id}`);
    },
    deleteModule(json) {
        return Repository.post(`${resource}/deleteModule${Utils.appendCorsParam()}`, Utils.toFormData(json));
    },
    deleteTargeting(json) {
        return Repository.post(`${resource}/deleteTargeting${Utils.appendCorsParam()}`, Utils.toFormData(json));
    },
    editTargeting(json) {
        return Repository.post(`${resource}/editTargeting${Utils.appendCorsParam()}`, Utils.toFormData(json));
    },
    getGeneralTargetingList() {
        return Repository.get(`${resource}/getGeneralTargetingList${Utils.appendCorsParam()}`);
    },
    getTargetingListByPublisherId(id) {
        return Repository.get(`${resource}/getTargetingListByPublisherId${Utils.appendCorsParam()}&publisher_id=${id}`);
    },
    getAllSites(id) {
        return Repository.get(`/service.php/management/getSitesWithout${Utils.appendCorsParam()}&publisher_id=${id}`);
    },
}